import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M10.1580171,8 L15.55306,13.3950429 C16.14898,13.9909629 16.14898,14.95714 15.55306,15.55306 C14.95714,16.14898 13.9909629,16.14898 13.3950429,15.55306 L8,10.1580171 L2.60495713,15.55306 C2.00903715,16.14898 1.04285997,16.14898 0.446939985,15.55306 C-0.148979995,14.95714 -0.148979995,13.9909629 0.446939985,13.3950429 L5.84198285,8 L0.446939985,2.60495713 C-0.148979995,2.00903715 -0.148979995,1.04285997 0.446939985,0.446939982 C1.04285997,-0.148979995 2.00903715,-0.148979995 2.60495713,0.446939982 L8,5.84198285 L13.3950429,0.446939982 C13.9909629,-0.148979995 14.95714,-0.148979995 15.55306,0.446939982 C16.14898,1.04285997 16.14898,2.00903715 15.55306,2.60495713 L10.1580171,8 Z"
      transform="translate(4 4)"
      fill={fill}
    />
  </g>
);

export default Icon;
